import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  Typography,
  Slider,
} from '@material-ui/core';

class EditStageDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      stageName: "",
      allowNextStage: "1",
      stageMinute: 0,
      stageSecond: 0,
      panoramaFormat: 0,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false,
    });
    this.state.open = false;
  }

  updateStageDetail() {
    if (this.props.parent.state.selectedStage != null) {
      let stage = this.props.parent.state.selectedStage;
      let name = stage['stage_name'];
      let min = Math.floor(stage['duration'] / 60.0);
      let sec = Math.floor(stage['duration']) % 60;
      let nextStage = stage['allow_enter_next_stage'];
      let format = stage['panorama_format'];
      this.setState({
        stageName: name,
        stageMinute: min,
        stageSecond: sec,
        allowNextStage: nextStage,
        panoramaFormat: format,
      });
      this.state.stageName = name;
      this.state.stageMinute = min;
      this.state.stageSecond = sec;
      this.state.allowNextStage = nextStage;
      this.state.panoramaFormat = format;
    }
  }

  validateInput() {
    let result = true;
    let errorMessage = "";
    if (this.state.stageName.trim() == "") {
      errorMessage = "Name cannot be empty";
      result = false;
    }
    else if (this.state.stageMinute == 0 && this.state.stageSecond == 0) {
      errorMessage = "Duration cannot be zero";
      result = false;
    }
    if (errorMessage != "") {
        this.props.root.addNotification(errorMessage);
    }

    return result;
  }

  updateStageClicked() {
    if (this.validateInput()) {
      this.props.parent.updateStageSetting();
    }
  }

  allowNextStageChanged(e) {
    this.setState({
      allowNextStage: e.target.value,
    });
    this.state.allowNextStage = e.target.value;
  }

  stageNameChanged(e) {
    this.setState({
      stageName: e.target.value,
    });
    this.state.stageName = e.target.value;
  }

  handleMinuteChanged = (event, value) => {
    this.setState({
      stageMinute: value,
    })
    this.state.stageMinute = value;
  }

  handleSecondChanged = (event, value) => {
    this.setState({
      stageSecond: value,
    })
    this.state.stageSecond = value;
  }

  panoramaFormatChanged(e) {
    this.setState({
      panoramaFormat: e.target.value,
    });
    this.state.panoramaFormat = e.target.value;
  }

  render() {
    return (
      <div style={{overflow:'hidden'}}>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle>{Localization.strings.EDIT_STAGE}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={2}>
                {Localization.strings.NAME}
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  value={this.state.stageName}
                  onChange={this.stageNameChanged}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                {Localization.strings.ENTER_NEXT_STAGE}
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.allowNextStage}
                    onChange={this.allowNextStageChanged}
                  >
                    <MenuItem key={1} value={"1"}>{Localization.strings.YES}</MenuItem>
                    <MenuItem key={0} value={"0"}>{Localization.strings.NO}</MenuItem>
                  </Select>
                  <FormHelperText>If set to NO, be sure to create a portal</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                {Localization.strings.DURATION}
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography align="center">
                  {this.state.stageMinute + " " + Localization.strings.MINUTE_S}
                </Typography>
                <div style={{padding:"14px 0 14px 0"}}>
                  <Slider
                    value={this.state.stageMinute}
                    min={0}
                    max={60}
                    step={1}
                    onChange={this.handleMinuteChanged}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography align="center">:</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography align="center">
                  {this.state.stageSecond + " " + Localization.strings.SECOND_S}
                </Typography>
                <div style={{padding:"14px 0 14px 0"}}>
                  <Slider
                    value={this.state.stageSecond}
                    min={0}
                    max={60}
                    step={5}
                    onChange={this.handleSecondChanged}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={2}>
                {Localization.strings.PANORAMA_FORMAT}
                <FormHelperText>For Advanced user.</FormHelperText>
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.panoramaFormat}
                    onChange={this.panoramaFormatChanged}
                  >
                    <MenuItem key={0} value={0}>2D Monoscopic</MenuItem>
                    <MenuItem key={1} value={1}>3D Stereoscopic Over/Under</MenuItem>
                    <MenuItem key={2} value={2}>3D Stereoscopic Side By Side</MenuItem>
                  </Select>
                  <FormHelperText>Aspect Ratio {this.state.panoramaFormat == 0 || this.state.panoramaFormat == 2? "2:1" : "1:1"}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CANCEL}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.updateStageClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EditStageDialog;
